function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { forwardRef, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Divider, Descriptions, Row as ARow, Col as ACol, QRCode, Tag, Radio, Alert, Table, Form } from 'antd';
import { EyeFill, EarFill } from 'react-bootstrap-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment';
import Moment from 'react-moment';
import Common from "./includes/Common";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Certificate = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var candidat = _ref.candidat;

  //console.log(JSON.stringify(customer));     
  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  useEffect(function () {
    form.setFieldsValue({
      conclusion: candidat.conclusion.conclusion
    });
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs("div", {
        ref: ref,
        id: "printable",
        children: [/*#__PURE__*/_jsx(ARow, {
          children: /*#__PURE__*/_jsx(ACol, {
            span: 16,
            offset: 8,
            children: /*#__PURE__*/_jsxs("div", {
              style: {
                padding: "8px",
                color: "#EEE",
                background: "#168794",
                clear: "both"
              },
              children: [/*#__PURE__*/_jsx("h2", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "CERTIFICAT MEDICAL D'APTITUDE"
                })
              }), /*#__PURE__*/_jsxs("span", {
                children: ["N\xBA ", candidat.candidate_code]
              })]
            })
          })
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(ARow, {
          gutter: 8,
          children: /*#__PURE__*/_jsx(ACol, {
            span: 24,
            children: /*#__PURE__*/_jsxs("div", {
              className: "pad cool-radius",
              children: [/*#__PURE__*/_jsxs("p", {
                style: {
                  fontSize: "16px"
                },
                children: ["Je soussign\xE9, ", /*#__PURE__*/_jsx("b", {
                  children: "Dr Assietou Rachid CAMARA"
                }), ", Certifie avoir examin\xE9 ", /*#__PURE__*/_jsx("b", {
                  children: candidat.name
                }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Descriptions, {
                  bordered: true,
                  column: 1,
                  size: "small",
                  children: [/*#__PURE__*/_jsxs(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "\xC2GE"
                    }),
                    children: [moment(candidat.birthdate).diff(moment(), 'years') * -1, " ans. "]
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "POSTE DE TRAVAIL"
                    }),
                    children: candidat.job
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "MATRICULE"
                    }),
                    children: candidat.matricule
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "LIEU DE RESIDENCE"
                    }),
                    children: candidat.address
                  }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "MOTIF"
                    }),
                    children: [candidat.reason == 0 && /*#__PURE__*/_jsx("span", {
                      children: "VISITE ANNUELLE"
                    }), " ", candidat.reason == 1 && /*#__PURE__*/_jsx("span", {
                      children: "PRE-EMBAUCHE"
                    }), " ", candidat.reason == 2 && /*#__PURE__*/_jsx("span", {
                      children: "PERMIS DE TRAVAIL"
                    })]
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "ENTREPRISE"
                    }),
                    children: candidat.company.label
                  })]
                }), /*#__PURE__*/_jsx("br", {})]
              }), /*#__PURE__*/_jsx("b", {
                children: "Et le d\xE9clare :"
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
                style: {
                  width: "530px"
                },
                children: /*#__PURE__*/_jsx(Form, {
                  form: form,
                  children: /*#__PURE__*/_jsxs(Form.Item, {
                    name: "conclusion",
                    children: [candidat.reason == 1 && /*#__PURE__*/_jsxs(Radio.Group, {
                      size: "large",
                      children: [/*#__PURE__*/_jsx(Radio, {
                        disabled: candidat.conclusion.conclusion != 8,
                        checked: candidat.conclusion.conclusion == 8,
                        value: 8,
                        children: /*#__PURE__*/_jsx("b", {
                          children: "Apte au poste de travail souhait\xE9"
                        })
                      }), /*#__PURE__*/_jsx(Radio, {
                        disabled: candidat.conclusion.conclusion != 9,
                        checked: candidat.conclusion.conclusion == 9,
                        value: 9,
                        children: /*#__PURE__*/_jsx("b", {
                          children: "Apte au poste de travail souhait\xE9 am\xE9nagement"
                        })
                      }), /*#__PURE__*/_jsx(Radio, {
                        disabled: candidat.conclusion.conclusion != 10,
                        checked: candidat.conclusion.conclusion == 10,
                        value: 10,
                        children: /*#__PURE__*/_jsx("b", {
                          children: "Apte au poste de travail souhait\xE9 avec restriction"
                        })
                      }), /*#__PURE__*/_jsx(Radio, {
                        disabled: candidat.conclusion.conclusion != 11,
                        checked: candidat.conclusion.conclusion == 11,
                        value: 11,
                        children: /*#__PURE__*/_jsx("b", {
                          children: "Apte au poste souhait\xE9 sous reserve d'une consultation"
                        })
                      }), /*#__PURE__*/_jsx(Radio, {
                        disabled: candidat.conclusion.conclusion != 12,
                        checked: candidat.conclusion.conclusion == 12,
                        value: 12,
                        children: /*#__PURE__*/_jsx("b", {
                          children: "Inapte temporaire au poste de travail souhait\xE9"
                        })
                      }), /*#__PURE__*/_jsx(Radio, {
                        disabled: candidat.conclusion.conclusion != 13,
                        checked: candidat.conclusion.conclusion == 13,
                        value: 13,
                        children: /*#__PURE__*/_jsx("b", {
                          children: "Inapte d\xE9finitif au poste de travail souhait\xE9 avec reclassement"
                        })
                      }), /*#__PURE__*/_jsx(Radio, {
                        disabled: candidat.conclusion.conclusion != 14,
                        checked: candidat.conclusion.conclusion == 14,
                        value: 14,
                        children: /*#__PURE__*/_jsx("b", {
                          children: "Inapte d\xE9finitif"
                        })
                      })]
                    }), (candidat.reason == 0 || candidat.reason == 2) && /*#__PURE__*/_jsxs(Radio.Group, {
                      size: "large",
                      children: [/*#__PURE__*/_jsx(Radio, {
                        disabled: candidat.conclusion.conclusion != 1,
                        checked: candidat.conclusion.conclusion == 1,
                        value: 1,
                        children: /*#__PURE__*/_jsx("b", {
                          children: "Apte au poste de travail occup\xE9"
                        })
                      }), /*#__PURE__*/_jsx(Radio, {
                        disabled: candidat.conclusion.conclusion != 2,
                        checked: candidat.conclusion.conclusion == 2,
                        value: 2,
                        children: /*#__PURE__*/_jsx("b", {
                          children: "Apte au poste de travail occup\xE9 am\xE9nagement"
                        })
                      }), /*#__PURE__*/_jsx(Radio, {
                        disabled: candidat.conclusion.conclusion != 3,
                        checked: candidat.conclusion.conclusion == 3,
                        value: 3,
                        children: /*#__PURE__*/_jsx("b", {
                          children: "Apte au poste de travail occup\xE9 avec restriction"
                        })
                      }), /*#__PURE__*/_jsx(Radio, {
                        disabled: candidat.conclusion.conclusion != 7,
                        checked: candidat.conclusion.conclusion == 7,
                        value: 7,
                        children: /*#__PURE__*/_jsx("b", {
                          children: "Apte au poste occup\xE9 sous reserve d'une consultation"
                        })
                      }), /*#__PURE__*/_jsx(Radio, {
                        disabled: candidat.conclusion.conclusion != 4,
                        checked: candidat.conclusion.conclusion == 4,
                        value: 4,
                        children: /*#__PURE__*/_jsx("b", {
                          children: "Inapte temporaire au poste de travail occup\xE9"
                        })
                      }), /*#__PURE__*/_jsx(Radio, {
                        disabled: candidat.conclusion.conclusion != 5,
                        checked: candidat.conclusion.conclusion == 5,
                        value: 5,
                        children: /*#__PURE__*/_jsx("b", {
                          children: "Inapte d\xE9finitif au poste de travail occup\xE9 avec reclassement"
                        })
                      }), /*#__PURE__*/_jsx(Radio, {
                        disabled: candidat.conclusion.conclusion != 6,
                        checked: candidat.conclusion.conclusion == 6,
                        value: 6,
                        children: /*#__PURE__*/_jsx("b", {
                          children: "Inapte d\xE9finitif"
                        })
                      })]
                    })]
                  })
                })
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx("h4", {
                  style: {
                    textAlign: "center"
                  },
                  children: /*#__PURE__*/_jsx("b", {
                    children: "Observation:"
                  })
                }), /*#__PURE__*/_jsx("p", {
                  children: candidat.conclusion.comment
                })]
              }), /*#__PURE__*/_jsx("br", {}), candidat.conclusion.prevention_tips != null && /*#__PURE__*/_jsx(Tag, {
                type: "info",
                banner: true,
                message: candidat.conclusion.prevention_tips
              }), /*#__PURE__*/_jsxs("h6", {
                style: {
                  textAlign: "center"
                },
                children: [/*#__PURE__*/_jsx("b", {
                  children: "Conakry, le "
                }), /*#__PURE__*/_jsx(Moment, {
                  format: "DD/MM/YYYY"
                })]
              }), /*#__PURE__*/_jsx("br", {})]
            })
          })
        }), /*#__PURE__*/_jsxs(ARow, {
          children: [/*#__PURE__*/_jsx(ACol, {
            span: 8,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                textAlign: 'center'
              },
              children: /*#__PURE__*/_jsx("h5", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Le M\xE9decin du travail"
                })
              })
            })
          }), /*#__PURE__*/_jsx(ACol, {
            span: 8,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                textAlign: "center",
                paddingLeft: "85px"
              },
              children: /*#__PURE__*/_jsx(QRCode, {
                errorLevel: "H",
                size: 150,
                iconSize: 150 / 5,
                value: "https://mt.centremedvie.com/#/check/" + candidat.id,
                icon: "drawables/mvc.jpeg"
              })
            })
          }), /*#__PURE__*/_jsx(ACol, {
            span: 8,
            children: /*#__PURE__*/_jsxs("div", {
              style: {
                textAlign: 'center'
              },
              children: [/*#__PURE__*/_jsx("h5", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Le Directeur General"
                })
              }), /*#__PURE__*/_jsx("h5", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "MEDVIE"
                })
              })]
            })
          })]
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            style: {
              "float": 'left',
              width: '46%'
            },
            lg: 6,
            md: 6,
            sm: 6
          }), /*#__PURE__*/_jsx(Col, {
            style: {
              "float": 'left',
              width: '46%'
            },
            className: "g-col-6",
            lg: 6,
            md: 6,
            sm: 6
          })]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("h6", {
          style: {
            textAlign: "center",
            fontWeight: "bold"
          },
          children: "Approbation Service National de Sant\xE9 au Travail (SNST)"
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Alert, {
          type: "info",
          message: /*#__PURE__*/_jsx("b", {
            children: "Ce certificat est valide pour une ann\xE9e au maximum*, \xE0 partir de la date de d\xE9livrance"
          }),
          description: /*#__PURE__*/_jsxs("div", {
            children: ["Si des personnes ont cess\xE9s leurs activit\xE9s et qu'elles sont (ou ne sont) atteintes ou sont porteuses d'une maladie pendant l'exercice de leur travail, elles ne peuvent reprendre leurs activit\xE9s qu'apr\xE8s avoir obtenu un nouveau certificat", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("b", {
              children: ["Adresse: Prima Center, Commune de Ratoma, Conakry, R\xE9p. de Guin\xE9e", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
                children: "Tel: +224 621 72 49 21 - E-mail: info@medviegn.com"
              })]
            })]
          })
        })]
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
  });
});
export default Certificate;